export default [
  {
    name: 'pressreleases.pressreleases',
    pressreleases: [
      {
        title: 'Skycoin Project Releases Affordable High-Security Hardware Wallet',
        link: 'release-2019-11-26',
        dates: 'November 26, 2019',
      },
      {
        title: 'Secure and Private “New Internet” Skywire set to Launch in New York City',
        link: 'release-2019-10-18',
        dates: 'October 18, 2019',
      },
      {
        title: 'Skycoin Project Releases Hardware Development Kit (HDK) for New Cryptocurrency Wallet',
        link: 'release-2019-10-14',
        dates: 'October 14, 2019',
      },
      {
        title: 'Early Bitcoin and Ethereum Developers Set to Roll-Out "Skywire" - a New, Decentralized Internet from Skycoin',
        link: 'release-2019-08-23',
        dates: 'August 23, 2019',
      },
      {
        title: 'Skycoin Announces Public Release of Skywire Mainnet',
        link: 'release-2019-03-20',
        dates: 'March 20, 2019',
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/components/PressReleases/data.js